import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import {
  isMediaAudio,
  isMediaImage,
  isMediaVideo,
  getHtmlFileType,
} from 'components/FileUpload/utils';

import messages from 'containers/QuestionnairePage/QuestionGroup/ABTest/Concepts/messages';

function AttributeValue({ value }) {
  const { media, text } = value;

  const isImage = isMediaImage(value.media);
  const isAudio = isMediaAudio(value.media);
  const isVideo = isMediaVideo(value.media);
  const htmlFileType = getHtmlFileType(value.media || {});

  return (
    <div className="display-flex flex-items-center flex-justify-center flex-1">
      {!text && !media ? (
        <button
          type="button"
          className={classNames(
            'text-weight-500',
            'border-grey-6',
            'transition-normal',
            'background-transparent',
            'text-size-secondary',
            'border-radius-level-1',
            'padding-horizontal-xs',
            'padding-vertical-xxs',
            'shadow-none',
            'color-grey-7',
          )}
          disabled
        >
          <FormattedMessage {...messages.addFile} />
        </button>
      ) : (
        <React.Fragment>
          <div role="presentation" className="w-full">
            {text && (
              <div
                style={{ minHeight: '20px' }}
                className={classNames(
                  'padding-xs',
                  'margin-none',
                  'border-grey-6',
                  'border-dashed-important',
                  'border-radius-level-1',
                  'transition-normal',
                  {
                    'margin-btm-sm': media && media.url,
                  },
                )}
              >
                <div
                  className="color-grey-10 text-size-secondary"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: value.text || '' }}
                />
              </div>
            )}

            {media && media.url && (
              <div
                className={classNames(
                  'border-grey-6',
                  'border-dashed',
                  'border-dashed-important',
                  'border-radius-level-1',
                )}
              >
                <div
                  style={{
                    height: 132,
                    maxWidth: 132,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  {isImage && (
                    <img
                      className="w-full h-full background-white"
                      alt={text}
                      style={{
                        objectFit: 'contain',
                      }}
                      src={value.media.url}
                    />
                  )}
                  {isAudio && (
                    <audio //eslint-disable-line
                      controls
                      className="h-full background-white"
                      style={{
                        width: 132,
                      }}
                    >
                      <source src={value.media.url} type={htmlFileType} />
                    </audio>
                  )}
                  {isVideo && (
                    <video //eslint-disable-line
                      controls
                      className="w-full h-full background-white"
                      style={{
                        objectFit: 'cover',
                      }}
                    >
                      <source src={value.media.url} type={htmlFileType} />
                    </video>
                  )}
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

AttributeValue.propTypes = {
  refId: PropTypes.string,
  value: PropTypes.object,
};

export default AttributeValue;
